import { createStore } from "vuex";
import { config } from "vuex-module-decorators";

import AuthModule from "@/store/modules/AuthModule";
import BodyModule from "@/store/modules/BodyModule";
import BreadcrumbsModule from "@/store/modules/BreadcrumbsModule";
import ConfigModule from "@/store/modules/ConfigModule";
import CountryModule from "@/store/modules/CountryModule";
import { SOCIETES, DEFAULT_SOCIETE, isSocieteLabel } from "@/config/societes";
import { applySocietePalette } from "@/layout/composables/societePalette";

const SELECTED_SOCIETE_KEY = "selected_societe";

config.rawError = true;

const store = createStore({
  modules: {
    AuthModule,
    BodyModule,
    BreadcrumbsModule,
    ConfigModule,
    CountryModule,
    domain: {
      namespaced: true,
      state: () => ({
        // Société (marque) active sélectionnée par l'utilisateur. C'est désormais
        // la source du branding et la valeur envoyée dans le header x-domain.
        selectedSociete: null,
        bitrixBaseUrl: null,
        color: null,
        colorText: null,
        vehiclesIndex: null,
        societe: null,
        logo: null,
      }),
      getters: {
        // Renvoie le libellé société actif : c'est la valeur envoyée dans x-domain.
        getDomain(state) {
          return state.societe;
        },

        getSelectedSociete(state) {
          return state.selectedSociete;
        },

        getVehicleImageIndices:
          (state, getters, rootState, rootGetters) =>
          (vehicleCompany, sellerSociete = null) => {
            const userSociete =
              sellerSociete || rootGetters.getCurrentUser?.societe;
            if (vehicleCompany === userSociete) {
              return { firstImage: 0, secondImage: 1 };
            }
            if (vehicleCompany === "POLARIS MONT-BLANC") {
              return { firstImage: 0, secondImage: 1 };
            }
            if (vehicleCompany === "POLARIS MONT-BLANC") {
              return { firstImage: 0, secondImage: 1 };
            }
            // Indices d'emplacement (0 = photo1). Vehicule d'une autre societe :
            // studio de la societe de l'utilisateur en couverture, sans plaque
            // arriere (photo22) en second.
            let firstImage = 20;
            if (userSociete === "JUGAND AUTOS") firstImage = 22;
            // Studio Balleydier 4x4 : photo25 (l'indice 23 visait photo24, la
            // scene Distinxion).
            else if (userSociete === "BALLEYDIER 4X4") firstImage = 24;
            // Studio Auto Evasion (photo26), decline des vues brutes MyCarLab.
            else if (userSociete === "AUTO EVASION") firstImage = 25;
            return { firstImage, secondImage: 21 };
          },
      },
      mutations: {
        // Définit la société active et applique tout son branding.
        // Persiste le choix en localStorage et met à jour la palette PrimeVue.
        setSelectedSociete(state, label) {
          const resolved = isSocieteLabel(label) ? label : DEFAULT_SOCIETE;
          const cfg = SOCIETES[resolved];

          state.selectedSociete = resolved;
          state.societe = cfg.label;
          state.color = cfg.color;
          state.colorText = cfg.colorText;
          state.vehiclesIndex = cfg.vehiclesIndex;
          state.bitrixBaseUrl = cfg.bitrixBaseUrl;
          state.logo = cfg.logo;

          try {
            window.localStorage.setItem(SELECTED_SOCIETE_KEY, resolved);
          } catch (e) {
            // localStorage indisponible — on ignore silencieusement
          }

          applySocietePalette(resolved);
        },
      },
    },
  },
});

export default store;
